import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1>About Us</h1>
        <p>Learn more about SCL Networks and our journey</p>
      </section>

      <section className="about-story">
        <div className="story-content">
          <h2>Our Story</h2>
          <p>SCL Networks Pvt Ltd is a leading web development company dedicated to delivering innovative digital solutions. With years of experience in the industry, we've helped numerous businesses establish their online presence and achieve their digital goals.</p>
          <p>Our commitment to excellence and customer satisfaction has made us a trusted partner for businesses worldwide. We combine technical expertise with creative thinking to deliver solutions that drive results.</p>
        </div>
        <div className="story-image">
          <img src="/images/about/team-meeting.jpg" alt="SCL Networks Team" />
        </div>
      </section>

      <section className="mission-vision">
        <div className="mission">
          <i className="fas fa-bullseye"></i>
          <h2>Our Mission</h2>
          <p>To empower businesses with innovative web solutions that drive growth and success in the digital world.</p>
        </div>
        <div className="vision">
          <i className="fas fa-eye"></i>
          <h2>Our Vision</h2>
          <p>To be the leading web development company known for excellence, innovation, and customer satisfaction.</p>
        </div>
      </section>

      <section className="values">
        <h2>Our Core Values</h2>
        <div className="values-grid">
          <div className="value-item">
            <i className="fas fa-handshake"></i>
            <h3>Integrity</h3>
            <p>We conduct our business with the highest standards of professional behavior and ethics.</p>
          </div>
          <div className="value-item">
            <i className="fas fa-lightbulb"></i>
            <h3>Innovation</h3>
            <p>We constantly explore new technologies and approaches to deliver cutting-edge solutions.</p>
          </div>
          <div className="value-item">
            <i className="fas fa-users"></i>
            <h3>Collaboration</h3>
            <p>We believe in working together to achieve the best possible outcomes for our clients.</p>
          </div>
          <div className="value-item">
            <i className="fas fa-chart-line"></i>
            <h3>Excellence</h3>
            <p>We strive for excellence in everything we do, from code quality to customer service.</p>
          </div>
        </div>
      </section>

      <section className="team">
        <h2>Our Leadership Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <div className="member-image">
              <img src="/images/team/gurpreet-litt.jpg" alt="Gurpreet Litt" />
            </div>
            <div className="member-info">
              <h3>Gurpreet Litt</h3>
              <p className="position">CEO & Founder</p>
              <p className="bio">A visionary leader with 22+ years of experience in web development, specializing in PHP, Laravel, and enterprise solutions. Expert in building scalable web applications and leading complex projects.</p>
            </div>
          </div>

          <div className="team-member">
            <div className="member-image">
              <img src="/images/team/kuldeep-choudhry.jpg" alt="Kuldeep Choudhry" />
            </div>
            <div className="member-info">
              <h3>Kuldeep Choudhry</h3>
              <p className="position">Technical Director</p>
              <p className="bio">Over 20 years of expertise in full-stack development, focusing on modern web technologies and cloud solutions. Skilled in architecting robust and scalable applications.</p>
            </div>
          </div>

          <div className="team-member">
            <div className="member-image">
              <img src="/images/team/amit-kumar-som.jpg" alt="Amit Kumar Som" />
            </div>
            <div className="member-info">
              <h3>Amit Kumar Som</h3>
              <p className="position">Creative Director</p>
              <p className="bio">20+ years of experience in UI/UX design and front-end development. Passionate about creating intuitive user experiences and implementing modern design principles.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="stats">
        <div className="stat-item">
          <h3>10+</h3>
          <p>Years of Experience</p>
        </div>
        <div className="stat-item">
          <h3>500+</h3>
          <p>Projects Completed</p>
        </div>
        <div className="stat-item">
          <h3>300+</h3>
          <p>Happy Clients</p>
        </div>
        <div className="stat-item">
          <h3>50+</h3>
          <p>Team Members</p>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Work With Us?</h2>
        <p>Let's discuss how we can help you achieve your goals</p>
        <Link to="/contact" className="cta-button">Get in Touch</Link>
      </section>
    </div>
  );
};

export default About; 